module.exports = __webpack_public_path__ + "img/credential-4.10c2d7c7.png";